export const userInfo = {
    '& > div:first-child': {
        flex: 'initial',
        marginRight: '10px',
    },
    'alignItems': 'center',
    'display': 'flex',
}

export const acceptWrapper = {'&& button > svg': {color: '$success'}}

export const checkList = {
    marginBottom: '$channelInviteItemContainerPaddingVertical',
    padding: 0,
}

export const checkItem = {
    '& svg': {
        color: '$success',
        marginRight: '5px',
    },
    'alignItems': 'flex-start',
    'display': 'flex',
    'listStyle': 'none',
    'marginBottom': '$channelInviteItemPaddingVertical',
}

export const overflowWrapper = {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line sort-keys
    variants: {multiline: {true: {whiteSpace: 'normal'}}},
}

export const contentWrapper = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5em',
    maxHeight: '60vh',
    overflowY: 'auto',
}
